import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconChevronLeft from '@adv-mt/mt-svg-icons/lib/ChevronLeftDefault'
import IconChevronRight from '@adv-mt/mt-svg-icons/lib/ChevronRightDefault'

import CardsCarouselNavButton from './CardsCarouselNavButton.js'
import focusSiblingCard from './focusSiblingCard.js'
import useCardsCarouselScroll from './useCardsCarouselScroll.js'

const BASE_CLASS = 'mt-SharedCardsCarousel'

const SharedCardsCarousel = ({children, className, titleNode}) => {
  const {i18n} = useContext(Context)
  const {atEnd, atStart, scrollNext, scrollPrev, scrollRef} = useCardsCarouselScroll()

  return (
    <div className={cx(BASE_CLASS, className)}>
      <div className={`${BASE_CLASS}-header`}>
        {titleNode}
        <div className={`${BASE_CLASS}-nav`}>
          <CardsCarouselNavButton
            aria-label={i18n.t('COMMON.PREVIOUS')}
            disabled={atStart}
            icon={IconChevronLeft}
            onClick={scrollPrev}
          />
          <CardsCarouselNavButton
            aria-label={i18n.t('COMMON.NEXT')}
            disabled={atEnd}
            icon={IconChevronRight}
            onClick={scrollNext}
          />
        </div>
      </div>
      <div className={`${BASE_CLASS}-track`} onKeyDown={focusSiblingCard} ref={scrollRef}>
        {children}
      </div>
    </div>
  )
}

SharedCardsCarousel.displayName = 'SharedCardsCarousel'

SharedCardsCarousel.propTypes = {
  /**
   * The cards. Each one is a direct flex item of the scrolling track and keeps the width it
   * declares for itself, so the carousel fits as many per view as the available space allows.
   */
  children: PropTypes.node,
  /** Rendered as-is, so every consumer picks its own typography (Headline1, Subhead1, Body1…). */
  titleNode: PropTypes.node,
  /** Extra classname */
  className: PropTypes.string
}

export default SharedCardsCarousel
